<template>
    <v-container fluid>
        <v-combobox
                v-model="model"
                :items="items"
                hide-selected
                multiple
                small-chips
                dense
                outlined
        >
            <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        :color="`grey lighten-2`"
                        :input-value="selected"

                >
                    <span class="pr-2">
                        {{ item.text }}
                    </span>
                    <v-icon style="cursor:pointer"
                            small
                            :id="item.text"
                            @click="($event)=>{
                                parent.selectItem(item)
                                $emit('delete', $event.target.id)
                            }"
                    >
                        $delete
                    </v-icon>
                </v-chip>
            </template>
        </v-combobox>
    </v-container>
</template>

<script>

  export default {
    name: 'ComboBoxWithDelete',
    props: {
      value: { type: Array, required: false },
      onlyNumbers: { type: Boolean, required: false, default: false }
    },
    data: () => ({
      dadosIniciais: [],
      activator: null,
      attach: null,
      colors: ['grey'],
      editing: null,
      editingIndex: -1,
      items: [
      ],
      nonce: 1,
      menu: false,
      x: 0,
      y: 0,
      model: []
    }),

    watch: {
      model (val, prev) {
        let permissaoDeAdicionar = true
        const onlyNumbers = new RegExp('^[0-9]+$')
        if (val.length === prev.length) return

        this.model = val.map(v => {
          if (v == null && this.value == null) {
            return
          }

          if ((typeof (v) === 'string' && !(onlyNumbers.test(v))) && this.onlyNumbers) {
            permissaoDeAdicionar = false
          }

          if (typeof v === 'string' && +v && v !== null) {
            v = {
              text: v
            }
            this.items.push(v)
            this.nonce++
          }
          return v
        })
        if (this.verificar()) {
          this.devolverDados(permissaoDeAdicionar)
        }
      }
    },
    mounted () {
      if (this.value != null) {
        let objValues = this.value.map(value => {
          return { 'text': value }
        })
        this.model = objValues
      }
    },
    methods: {
      removerUltimoItemDaLista () {
        this.model.pop()
      },
      verificar () {
        return !(this.model.every(value => {
          if (this.value == null) {
            return false
          }
          return this.value.includes(value.text)
        }
        ))
      },
      edit (index, item) {
        if (!this.editing) {
          this.editing = item
          this.editingIndex = index
        } else {
          this.editing = null
          this.editingIndex = -1
        }
      },
      devolverDados (permissaoDeAdicionar = true) {
        if (permissaoDeAdicionar === false) {
          this.removerUltimoItemDaLista()
          return false
        }
        this.$emit('data', this.model.map(v => +v.text))
      }
    }
  }

</script>
